import type { Room } from 'colyseus.js';

type OnlineSession = {
  room: Room | null;
};

const session: OnlineSession = {
  room: null,
};

export function setOnlineRoom(room: Room): void {
  session.room = room;
}

export function getOnlineRoom(): Room | null {
  return session.room;
}

export function clearOnlineRoom(): void {
  try {
    session.room?.removeAllListeners?.();
  } finally {
    session.room = null;
  }
}

